import {
  EMBEDDED_LENDING_ASSETS_URL,
  NEW_NAV_S3_ASSETS_URL,
  NEW_NAV_S3_SUB_ASSETS_URL,
} from "../../constants/Url";

export const defaultOtherProductsData = [
  {
    id: 0,
    title: "Payment Links",
    body:
      "No-code payment links to collect payments over WhatsApp, SMS, Facebook, Twitter and other channels",
    url: "/payment-links",
    iconname: `${NEW_NAV_S3_ASSETS_URL}/payment-links.svg`,
  },
  {
    id: 1,
    title: "Subscriptions",
    body:
      "Accept recurring payments by auto-debiting customers’ accounts via standing instructions on card, e mandate via net banking option or UPI AutoPay. ",
    url: "/recurring-payment",
    iconname: `${NEW_NAV_S3_ASSETS_URL}/subscription.svg`,
  },
  {
    id: 2,
    title: "Easy Split ",
    body: "Split vendor commissions and manage marketplace settlements",
    url: "/easy-split/split-payment-gateway",
    iconname: `${NEW_NAV_S3_SUB_ASSETS_URL}/easy-split.svg`,
  },
  {
    id: 3,
    title: "AutoCollect ",
    body:
      "Collect and reconcile IMPS/NEFT/UPI payments using unique virtual accounts and UPI IDs.",
    url: "/virtual-payment-address/",
    iconname: `${NEW_NAV_S3_SUB_ASSETS_URL}/auto-collect-new.svg`,
  },
];

export const LendingMetaData = [
  {
    logo: `${EMBEDDED_LENDING_ASSETS_URL}/CreditLineInfrastructure.svg`,
    title: "Line of Credit",
    comingSoon: "",
    description:
      "Offer loans with pre-set limit that customers can draw on, when need be.",
  },
  {
    logo: `${EMBEDDED_LENDING_ASSETS_URL}/TermLoan.svg`,
    title: "Term Loan",
    comingSoon: "",
    description:
      "Offer a fix amount of capital and let customer pay back in installments over the term of the loan.",
  },
  {
    logo: `${EMBEDDED_LENDING_ASSETS_URL}/SupplyChainFinanceNew.svg`,
    title: "Supply Chain Financing and Invoice Discounting",
    comingSoon: "",
    description:
      "Provide working capital credit for your customers through invoice and inventory financing solutions.",
  },
  {
    logo: `${EMBEDDED_LENDING_ASSETS_URL}/BNPLNew.svg`,
    title: "Buy Now Pay Later",
    comingSoon: "",
    description:
      "Enable your customers to buy products/services instantly and pay at a later stage.",
  },
];
